import './gfRow';
import './gfModule';
import './gfElement';
import './gfTabs';
import './gfFormRender';
import './gfForm';
import './gfSettingAdv';
import './gfSettingGroup';
import './gfLeftSideBar';
import './gfQuickBar';
import './controls/index';

import type { TypeCategoriesRespon } from '@/app/types/editor/respon';
import { GET } from '@/app/api/index';
import store from '@/app/store/store';
import getParameterByName from '@/app/utils/getParameterByName';
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import { getEmbedAppUrl } from '@/utils/getEmbedAppUrl';
import { BUILDER_OPEN_NEW_TAB } from '@/constants/feature-flag-key';
import { postMessageToParent } from '@/app/utils/helpers';

/**
 * Sidebar class
 */
export class Sidebar {
  public $gfLeftSideBar: JQuery = jQuery('#gfLeftSideBar');

  /**
   * Init
   */
  public async Init(): Promise<undefined> {
    const snippets = await this.getAllSnippetFromServer();
    if (snippets) {
      store.setValue('__snippets', snippets);
    }

    return;
  }

  /**
   * getAllSnippetFromServer
   * @returns promise
   */
  private async getAllSnippetFromServer(): Promise<string | undefined> {
    let categories;
    try {
      const url = '/api/categories/all';
      const res = await GET(url);
      const shopifyDomain = getParameterByName('shop') ?? '';

      if (res && res.data) {
        categories = (res.data as TypeCategoriesRespon).categories;
      } else {
        // eslint-disable-next-line no-console
        console.log('Categories not found');
        if (checkKeyValid(BUILDER_OPEN_NEW_TAB)) {
          const url = getEmbedAppUrl(shopifyDomain);
          if (window.top) {
            window.top.location.href = url;
          } else {
            window.location.href = url;
          }
          return;
        }
        postMessageToParent({ type: 'windowCloseBuilder' });
        return;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Categories not found');
      // eslint-disable-next-line no-console
      console.log(e);
      return;
    }
    categories = categories.sort((a, b) => a.id - b.id);

    //add categories to store
    store.setValue('__snippetCategories', categories);

    const splitGroup = 5;
    const allRequests = [];
    const ids = [] as Array<number>;
    categories.forEach((category) => {
      ids.push(category.id);
    });

    for (let i = 0; i < ids.length; i = i + splitGroup) {
      let cids = '';
      const splitIds = ids.slice(i, i + splitGroup);
      cids = splitIds.join(',');

      const url = '/api/snippets/my?cids=' + cids;
      // const req = GET(url, undefined, 'html');
      // allRequests.push(req);
    }

    try {
      // const values = await Promise.all(allRequests);
      // console.log('values', values);
      // if (values && values.length) {
      //   let snippets = '';
      //   values.forEach((snippetsData) => {
      //     snippets += snippetsData.data;
      //   });
      //   return snippets;
      // }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      return;
    }
  }
}
